<template>
  <div class="mb-4">
    <div
      class="bg-custom-light-green rounded-top d-lg-flex flex-row px-3 py-2 align-items-center bd-highlight"
    >
      <div class="d-flex flex-row w-80 bd-highlight">
        <div class="color-secondary-6 font-14 mr-1">
          Nombre de Custodio:
        </div>
        <div class="font-weight-bold font-16">
          {{ custodianName | empty }}
        </div>
      </div>
    </div>

    <custom-callout
      has-toggle
      controlled
      :opened="item.isOpen"
      :border-color="item.statusColor"
      @click:open="toggle"
      class="border-radius-top-auto"
    >
      <div class="row m-0 d-flex align-items-center">
        <div class="col-md col-12 p-md-0">
          <div class="py-3">
            <custom-balloon
              dot
              class="mt-2"
              :background-color="item.statusColor"
              :text="item.statusName"
            />
          </div>
        </div>
        <div class="col-md-10 col-12 mb-3 mb-lg-0 pl-md-0">
          <div class="row font-weight-normal">
            <div class="col-md col-12">
              <div class="color-secondary-6 font-14">
                Título del Libro:
              </div>
              <div class="color-black font-16">
                {{ item.title | empty }}
              </div>
            </div>

            <div class="col-md col-12">
              <div class="color-secondary-6 font-14">
                Código del Libro:
              </div>
              <div class="color-black font-16">
                {{ item.code | empty }}
              </div>
            </div>
            <div class="col-md-1 col-12">
              <div class="color-secondary-6 font-14">
                Grado:
              </div>
              <div class="color-black font-16">
                {{ item.grade | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <div class="color-secondary-6 font-14">
                Medio de Lectura:
              </div>
              <div class="color-black font-16">
                {{ readingMedium?.value | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <drop-down
                always-show-dropdown
                :items="actionItems"
                class="float-md-right mt-2 mt-md-1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 border-bottom-2"></div>
      <div class="row py-3 m-0 d-flex align-items-center">
        <div class="col-md-2 col-12">
          <div class="color-secondary-6 font-14">
            Materia:
          </div>
          <div class="color-black font-16">
            {{ item.subject | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Centro:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ item.caat | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Municipio:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ item.municipality | empty }}
          </div>
        </div>
        <div class="col-md col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Escuela:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ item.school | empty }}
          </div>
        </div>
      </div>
      <template #edition>
        <div class="px-2">
          <div
            v-if="isAdditinalInfoSectionVisible || isTransferInfoSectionVisible"
            class="px-3 py-4"
          >
            <div class="bg-white px-4 py-2 rounded">
              <custom-tab
                no-nav-style
                nav-class="mb-4 mx-0 w-100"
                :default-active-tab="activeTab"
              >
                <custom-tab-item
                  title="Información del Libro"
                  nav-item-class="w-50 text-center"
                  nav-link-class="fs-17"
                >
                  <additional-info class="px-1" :item="item" />
                </custom-tab-item>
                <custom-tab-item
                  v-if="item.transfer?.id"
                  title="Información de Transferencia"
                  nav-item-class="w-50 text-center"
                  nav-link-class="fs-17"
                >
                  <transfer-request-info
                    :transfer-id="item.transfer?.id"
                    @close="close"
                    @refresh="toggle"
                  />
                </custom-tab-item>
              </custom-tab>
            </div>
          </div>

          <assign-student
            v-if="isAssignStudentSectionVisible"
            @close="close"
            @save="handlerAssignStudent"
          />
          <unassign-student
            v-if="isUnassignStudentSectionVisible"
            @close="close"
            @save="handlerUnassignStudent"
          />
          <confiscate-book
            v-if="isSeizeSectionVisible"
            :book="item"
            @close="close"
            @save="handlerConfiscate"
          />
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import IconView from "icon-view";
import { CustomTab, CustomTabItem } from "custom-tabs";
import CustomCallout from "custom-callout";
import DropDown from "dropdown";
import CustomBalloon from "custom-balloon";
import AssignStudent from "./AssignStudent";
import UnassignStudent from "./UnassignStudent";
import ConfiscateBook from "./ConfiscateBook.vue";
import ACTIONS from "@/utils/constants/inventoryBookRowActions";
import PROPERTIES from "@/utils/constants/inventory/bookItemProperties";
import peiAtServiceEquipmentStatus from "@/utils/constants/inventory/peiAtServiceEquipmentStatus";
import inventoryCatalogService from "@/services/api/inventorycatalog.api";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import AdditionalInfo from "@/views/books/inventoryCatalog/Management/components/AdditionalInfo.vue";
import InventoryManagementDetailTabs from "@/utils/constants/inventory/InventoryManagementDetailTabs";
import TransferRequestInfo from "@/views/books/inventoryCatalog/Management/components/TransferRequestInfo.vue";

const TEMPLATE_SECTION_INDEX = {
  ADDITIONAL_INFO: 0,
  ASSIGN_STUDENT: 1,
  UNASSIGN_STUDENT: 2,
  SEIZE: 3,
  TRANSFERINFO: 4
};

const TAB_ITEMS = {
  INFO: 0,
  TRANSFERINFO: 1
};

export default {
  name: "BookResultRow",
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    CustomTab,
    CustomTabItem,
    IconView,
    AssignStudent,
    UnassignStudent,
    ConfiscateBook,
    AdditionalInfo,
    TransferRequestInfo
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    actionsToShow: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      currentAction: null,
      activeTab: TAB_ITEMS.INFO,
      actions: ACTIONS,
      book: {}
    };
  },
  computed: {
    actionItems() {
      const actions = [
        {
          id: ACTIONS.AdditionalInfo,
          action: {
            name: "Información del Libro",
            icon: "fas fa-info-circle text-green",
            visible: true,
            click: async () => {
              this.activeTab = TAB_ITEMS.INFO;
              this.open(TEMPLATE_SECTION_INDEX.ADDITIONAL_INFO);
            }
          }
        },
        {
          id: ACTIONS.AssignStudent,
          action: {
            name: "Asignar Estudiante",
            icon: "fas fa-user-plus text-success",
            visible: this.isAssignStudentButtonVisible,
            click: () => this.open(TEMPLATE_SECTION_INDEX.ASSIGN_STUDENT)
          }
        },
        {
          id: ACTIONS.UnassignStudent,
          action: {
            name: "Desasignar Estudiante",
            icon: "fas fa-user-minus text-danger",
            visible: this.isUnassignStudentButtonVisible,
            click: () => this.open(TEMPLATE_SECTION_INDEX.UNASSIGN_STUDENT)
          }
        },
        {
          id: ACTIONS.CustodianHistory,
          action: {
            name: "Historial de Custodio",
            icon: "fas fa-history text-success",
            click: () => {
              this.$router.push({
                name: "InventoryBookDetails",
                params: {
                  id: this.item?.catalogId,
                  bookId: this.item?.id
                },
                query: { tab: InventoryManagementDetailTabs.Custodian }
              });
            }
          }
        },
        {
          id: ACTIONS.Seize,
          action: {
            name: "Decomisar",
            icon: "fas fa-ban text-danger",
            visible: this.isSeizeButtonVisible,
            click: () => this.open(TEMPLATE_SECTION_INDEX.SEIZE)
          }
        },
        {
          id: ACTIONS.TransferInfo,
          action: {
            name: "Información de Transferencia",
            icon: "fas fa-info-circle text-green",
            visible: this.hasTransferInfo,
            click: async () => {
              this.activeTab = TAB_ITEMS.TRANSFERINFO;
              this.open(TEMPLATE_SECTION_INDEX.TRANSFERINFO);
            }
          }
        }
      ];

      return actions
        .filter(x => this.actionsToShow.includes(x.id))
        .map(x => x.action);
    },
    academicYearId() {
      return this.currentAcademicYear().id;
    },
    readingMedium() {
      return this.item.properties?.find(
        x => x.name === PROPERTIES.ReadingMedium
      );
    },
    isAdditinalInfoSectionVisible() {
      return this.currentAction === TEMPLATE_SECTION_INDEX.ADDITIONAL_INFO;
    },
    isAssignStudentButtonVisible() {
      return (
        this.item.statusId === peiAtServiceEquipmentStatus.AssignedToTeacher
      );
    },
    isAssignStudentSectionVisible() {
      return this.currentAction === TEMPLATE_SECTION_INDEX.ASSIGN_STUDENT;
    },
    isUnassignStudentButtonVisible() {
      return (
        this.item.statusId === peiAtServiceEquipmentStatus.AssignedToStudent &&
        this.item.student.id
      );
    },
    isUnassignStudentSectionVisible() {
      return this.currentAction === TEMPLATE_SECTION_INDEX.UNASSIGN_STUDENT;
    },
    isSeizeButtonVisible() {
      return [
        peiAtServiceEquipmentStatus.Returned,
        peiAtServiceEquipmentStatus.AssignedToStudent,
        peiAtServiceEquipmentStatus.AssignedToTeacher
      ].includes(this.item?.statusId);
    },
    isSeizeSectionVisible() {
      return this.currentAction === TEMPLATE_SECTION_INDEX.SEIZE;
    },
    isTransferInfoSectionVisible() {
      return this.currentAction === TEMPLATE_SECTION_INDEX.TRANSFERINFO;
    },
    hasTransferInfo() {
      return Boolean(this.item.transfer?.id);
    },
    custodianName() {
      return this.item.student?.name
        ? `${this.item.student?.name} / ${this.item.student?.id}`
        : this.item.user?.name;
    }
  },
  methods: {
    toggle() {
      this.item.isOpen ? this.close() : this.open();
    },
    open(section = TEMPLATE_SECTION_INDEX.ADDITIONAL_INFO) {
      this.currentAction = section;
      this.$emit("open", this.item);
    },
    close() {
      this.currentAction = null;
      this.$emit("close", this.item);
    },
    async handlerAssignStudent(payload) {
      try {
        payload.academicYearId = this.academicYearId;
        await inventoryCatalogService.assignStudent(this.item.id, payload);
        this.close();
        this.$emit("refresh");
        this.ShowToast(
          "Éxito",
          "El libro ha sido asignado exitosamente.",
          "success"
        );
      } catch (error) {
        this.ShowToast("Error", error?.response?.data.message, "error");
      }
    },
    async handlerUnassignStudent(payload) {
      payload.academicYearId = this.academicYearId;
      payload.sie = this.item.student.id;
      try {
        await inventoryCatalogService.unassignStudent(this.item.id, payload);
        this.close();
        this.$emit("refresh");
        this.ShowToast(
          "Éxito",
          "El libro ha sido desasignado exitosamente.",
          "success"
        );
      } catch (error) {
        this.ShowToast("Error", error?.response?.data.message, "error");
      }
    },
    async handlerConfiscate(model) {
      try {
        await inventoryCatalogService.consfiscateBook(model);
        this.close();
        this.$emit("refresh");
        this.ShowToast(
          "Éxito",
          "El libro ha sido decomizado exitosamente.",
          "success"
        );
      } catch (error) {
        this.ShowToast("Error", error?.response?.data.message, "error");
      }
    }
  }
};
</script>
<style scoped lang="scss">
::v-deep .balloon-container.success {
  background-color: #a3e5b3;
}
::v-deep .balloon-container.warning {
  background-color: #f8b539;
}

.border-radius-top-auto ::v-deep .border-radius--light {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.bg-custom-light-green {
  background-color: #d9e5dfba;
}
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
.border-bottom-2 {
  border-bottom: 2px solid #dee2e6 !important;
}
.custom-tab {
  --tab-active-color: #ff7058 !important;
}
</style>
